export const ENDPOINTS = {
    DASHBOARD: {
        GET_ALL_STATS: "/admin/dashboard-stats",
        FILTERED_STATS: (past: string) => `/admin/dashboard-stats-extended?past=${past}`,
        GET_EXTENDED_STATS: "/admin/dashboard-stats-extended",
    },
    ANALYTICS: {
        GET_ACTIVE_USERS: "/analytics/get-runReport-events"
    },
    AUTH: {
        WHOAMI: "/auth/admin/whoami",
        LOGIN: "/auth/admin/login",
        SEND_OTP: (email: string) => `/auth/admin/forget-password/${email}`,
        VERIFY_OTP: "/auth/admin/verify",
        RESET_PASSWORD: "/auth/admin/reset-password",
        LOGOUT: "/admin/logout"
    },
    ANNOUNCEMENTS: {
        GET_ALL: "/notifications/admin/all",
        DELETE_ANNOUNCEMENT: (id: string) => `/notifications/admin/${id}`,
    },
    SERVICES: {
        GET_ALL: '/admin/services/all',
        CANCEL_SERVICE: (serviceId: string) => `/admin/services/${serviceId}/cancel`,
        GET_SERVICE_BY_ID: (id: string) => `/admin/service/${id}`
    },
    BATCHES: {
        GET_ALL: '/admin/batches/all',
        GET_BATCH_BY_ID: (id: string) => `/admin/batch/${id}`,
        CLOSE_BATCH: (id: string) => `/admin/batch/${id}/close`,
        REMOVE_ORDER: (id: string) => `/admin/batch/${id}/remove-order`,
        MERGE_PREVIEW: '/admin/batch/merge/preview',
        MERGE: '/admin/batch/merge',
    },
    BATCH_CONFIGS: {
        GET: '/admin/batch-configs',
        UPDATE: '/admin/batch-configs',
    },
    USERS: {
        GET_ALL: '/admin/users/all',
        GET_USER_DETAILS: (id: string) => `/admin/user/${id}`
    },
    DRIVER: {
        VEHICLE_TYPE: "/vehicles/vehiclesDetails",
        GET_ALL_DRIVERS: "/admin/driver/all",
        BLOCK_DRIVER: (id: string) => `/admin/driver/${id}/modify`,
        GET_DRIVER_DETAILS: (id: string) => `/admin/driver/${id}`,
        MODIFY_DRIVER: (id: string) => `/admin/driver/${id}/modify`,
        GET_DRIVER_ADDRESS: (driverId: string) => `/admin/driver-address/${driverId}`,
        GET_DRIVER_ANALYSIS: (id: string) => `/admin/driver/${id}/analysis`,
    },
    STATES: {
        GET_ALL: "/states/getStates",
        GET_LAUNCHED_STATES: "/admin/states/all",
        DELETE_STATES: (id: string) => `/admin/states/${id}/delete`,
    },
    SUBMISSION_REQUEST: {
        GET_ALL: "/admin/request/all",
        MODIFY_REQUEST: (id: string) => `/admin/request/${id}/modify`,

    },
    FEEDBACK: {
        GET_ALL: "/admin/feedback/all",
        UPDATE_FEEDBACK: (feedbackId: string) => `/admin/feedback/${feedbackId}/modify`,
        UNREAD_COUNT_USER: "/admin/feedback/unread/count?userType=user",
        UNREAD_COUNT_DRIVER: "/admin/feedback/unread/count?userType=driver"
    },
    HELP_DESK: {
        GET_ALL_COMPLAINTS: "/admin/complaint/all",
    },
    ADMIN: {
        GET_ALL: "/admin/admins/all",
        DELETE_ADMIN: (id: string) => `/admin/admin/${id}/delete`,
        ADD_ADMIN: "/auth/admin/register"
    },
    PROMO_CODES: {
        GET_ALL: "/admin/promoCode/all",
        MODIFY_PROMO_CODE: (id: string) => `/admin/promoCode/${id}/togglePromoCode`,
        EDIT_PROMO_CODE: (id: string) => `/admin/promoCode/${id}/modify`,
        DELETE_PROMO_CODE: (id: string) => `/admin/promoCode/${id}/delete`,
        ADD_PROMO_CODE: "/promoCode/addPromoCode"

    },
    SUBSCRIPTION_PLANS: {
        GET_ALL: "/subscription-plan/get-all",
        GET_PLAN_TYPES: "/subscription-plan-type/get-all",
        DELETE_SUBSCRIPTION: (id: string) => `/subscription-plan/admin/delete/${id}`,
        TOGGLE_SUBSCRIPTION: (id: string) => `/subscription-plan/admin/edit/${id}`,
    },
    REFERRAL_OFFERS: {
        GET_ALL: "/referral-offer/get-all-offers",
        DELETE_REFERRAL_OFFER: (id: string) => `/referral-offer/${id}/delete`,
        TOGGLE_REFERRAL_OFFER: (id: string) => `/referral-offer/${id}/toggleOffer`,
    }
};